import React, { SFC, useState } from "react";
import { useLingui } from "@lingui/react";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { HelpCategory, HelpItem } from "./types";
import { HelpMenu } from "./HelpMenu";
import "./helpDialog.css";
import {
  Diesel_zwavelarm,
  IJR,
  LPG,
  Super_95_Ron,
  Super_95_Ron_E10,
  Super_98_Ron,
  Super_98_Ron_E10
} from "../../../settings";

export interface Props {
  onClose: () => void;
  defaultSelectedCategoryIndex?: number;
  defaultSelectedItemInCategoryIndex?: number;
}

export const HelpDialog: SFC<Props> = ({
  onClose,
  defaultSelectedCategoryIndex = 0,
  defaultSelectedItemInCategoryIndex = 0,
}) => {
  const {
    i18n: { locale },
  } = useLingui();
  const company = useWhiteLabelSetting("name");
  const [helpText, setHelpText] = useState<{ categories: HelpCategory[] }>();
  const [activeItem, setActiveItem] = useState<HelpItem>();
  const formatter = new Intl.NumberFormat('nl-BE', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

  const formatBrandstofprijs = (num: number) => formatter.format(num) + " €";

  React.useEffect(() => {
    const fn = async () => {
      const help = await require(`../../../assets/${company}/help_${locale}.json`);
      setHelpText(help);
      setActiveItem(help.categories[defaultSelectedCategoryIndex].items[defaultSelectedItemInCategoryIndex]);
    };
    fn();
  }, [company, locale, setHelpText, setActiveItem, defaultSelectedCategoryIndex, defaultSelectedItemInCategoryIndex]);

  return (
    <div id="help">
      <button id="helpclose" onClick={onClose}>
        X
      </button>
      {helpText && <HelpMenu helpCategories={helpText.categories} onChange={setActiveItem} activeItem={activeItem} />}
      {activeItem && (
        <div
          id="helpmain"
          dangerouslySetInnerHTML={{
            __html: activeItem.description
              .replace("{IJR}", "" + IJR)
              .replace("{Super_95_Ron}", formatBrandstofprijs(Super_95_Ron))
              .replace("{Super_95_Ron_E10}", formatBrandstofprijs(Super_95_Ron_E10))
              .replace("{Super_98_Ron}", formatBrandstofprijs(Super_98_Ron))
              .replace("{Super_98_Ron_E10}", formatBrandstofprijs(Super_98_Ron_E10))
              .replace("{Diesel_zwavelarm}", formatBrandstofprijs(Diesel_zwavelarm))
              .replace("{LPG}", formatBrandstofprijs(LPG))
            ,
          }}
        ></div>
      )}
    </div>
  );
};

HelpDialog.displayName = "HelpDialog";
